import { paths } from "../paths";

import NotFound from '../../components/main/layouts/errors/NotFound';

export const ErrorRoutes = [
 {
  path: paths.notFound,
  element: <NotFound />
 }
]